module.exports = __webpack_public_path__ + "static/media/programming.f54f6d00.png";